import { GiftCardJournalAction, GiftCardJournalActionInitiator, GiftCardJournalItem } from 'shared/models'
import { fakeGiftCards } from './fake-gift-cards'

export const fakeGiftCardJournal: GiftCardJournalItem[] = [
  {
    id: '1',
    dateTime: new Date().setHours(11, 5, 0, 0),
    actionType: GiftCardJournalAction.GiftCardCreation,
    actionInitiator: GiftCardJournalActionInitiator.Site,
    giftCard: fakeGiftCards[1]
  },
  {
    id: '2',
    dateTime: new Date().setHours(11, 5, 0, 0),
    actionType: GiftCardJournalAction.PaymentRequested,
    actionInitiator: GiftCardJournalActionInitiator.Auto,
    giftCard: fakeGiftCards[1],
    paymentInfo: {
      id: 1,
      link: 'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3',
      amount: 2000
    }
  },
  {
    id: '3',
    dateTime: new Date().setHours(11, 8, 0, 0),
    actionType: GiftCardJournalAction.PaymentConfirmed,
    actionInitiator: GiftCardJournalActionInitiator.Auto,
    giftCard: fakeGiftCards[1],
    paymentInfo: {
      id: 2,
      link: 'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3',
      amount: 2000
    }
  },
  {
    id: '2',
    dateTime: new Date().setHours(13, 47, 0, 0),
    actionType: GiftCardJournalAction.GiftCardStatusChanged,
    actionInitiator: GiftCardJournalActionInitiator.Auto,
    giftCard: fakeGiftCards[2]

  },
  {
    id: '4',
    dateTime: new Date().setHours(13, 48, 0, 0),
    actionType: GiftCardJournalAction.GiftCardStaffCommentChanged,
    actionInitiator: GiftCardJournalActionInitiator.Backoffice,
    giftCard: fakeGiftCards[0],
    user: {
      id: 1,
      firstName: 'Сергей',
      lastName: 'Иванов',
      email: 'admin@insidequest.ru'
    }
  },
  {
    id: '2',
    dateTime: new Date().setHours(13, 49, 0, 0),
    actionType: GiftCardJournalAction.GiftCardRedeem,
    actionInitiator: GiftCardJournalActionInitiator.Backoffice,
    giftCard: fakeGiftCards[1],
    user: {
      id: 1,
      firstName: 'Сергей',
      lastName: 'Иванов',
      email: 'admin@insidequest.ru'
    },
    redeemAmount: 2000,
    balance: 1000
  },
  {
    id: '2',
    dateTime: new Date().setHours(13, 49, 0, 0),
    actionType: GiftCardJournalAction.PaymentConfirmed,
    actionInitiator: GiftCardJournalActionInitiator.Backoffice,
    giftCard: fakeGiftCards[0],
    paymentInfo: {
      id: 2,
      link: 'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3',
      amount: 1000
    },
    user: {
      id: 1,
      firstName: 'Сергей',
      lastName: 'Иванов',
      email: 'admin@insidequest.ru'
    }
  },
  {
    id: '2',
    dateTime: new Date().setHours(14, 19, 0, 0),
    actionType: GiftCardJournalAction.PaymentRejected,
    actionInitiator: GiftCardJournalActionInitiator.Auto,
    giftCard: fakeGiftCards[0],
    paymentInfo: {
      id: 2,
      link: 'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3',
      amount: 1000
    }
  },
  {
    id: '5',
    dateTime: new Date().setHours(16, 15, 0, 0),
    actionType: GiftCardJournalAction.GiftCardRedeem,
    actionInitiator: GiftCardJournalActionInitiator.Backoffice,
    giftCard: fakeGiftCards[0],
    force: true,
    user: {
      id: 1,
      firstName: 'Сергей',
      lastName: 'Иванов',
      email: 'admin@insidequest.ru'
    },
    redeemAmount: 1000,
    balance: 0
  }
]
